export const getAvatarInitial = (name: string) => {
  const sanitizedFromPrefix = name.replace(/^\([^)]+\) /, '');
  const initialList = sanitizedFromPrefix.split(' ').map(word => word[0]);
  return [
    initialList[0],
    initialList[initialList.length > 1 ? initialList.length - 1 : 1],
  ]
    .filter(Boolean)
    .join('')
    .toUpperCase();
};
